import {
  WSAvatar,
  WSElement,
  WSElementProps,
  WSFlexBox,
  WSIcon,
  WSText,
  useIsMobile
} from "@wingspanhq/fe-component-library";
import { avatarBankAccount } from "../../../../shared/constants/avatars";
import { TransferType } from "../../types";
import styles from "./index.module.scss";

type Props = {
  type: TransferType;
} & WSElementProps;

export const TransferSchema: React.FC<Props> = ({ type, ...elementProps }) => {
  const isMobile = useIsMobile();

  return (
    <WSElement className={styles.transferSchema} {...elementProps}>
      {type === "deposit" ? <BankAccount /> : <Wingspan />}
      <WSIcon block name={isMobile ? "arrow-down" : "arrow-right"} />
      {type === "withdrawal" ? <BankAccount /> : <Wingspan />}
    </WSElement>
  );
};

const Wingspan: React.FC = () => {
  return (
    <WSFlexBox gap="S" alignItems="center" wrap="nowrap">
      <WSAvatar.Wingspan size="S" />
      <WSText.ParagraphSm color="gray500">Wingspan</WSText.ParagraphSm>
    </WSFlexBox>
  );
};

const BankAccount: React.FC = () => {
  return (
    <WSFlexBox gap="S" alignItems="center" wrap="nowrap">
      <WSAvatar {...avatarBankAccount} />
      <WSText.ParagraphSm color="gray500">Your bank account</WSText.ParagraphSm>
    </WSFlexBox>
  );
};
